// Add your custom JS here.

if (jQuery(window).width() < 767) {
    jQuery('.dropdown-toggle').each(function(){
        jQuery(this).attr('data-bs-toggle','dropdown'); 
    })
}

document.addEventListener('DOMContentLoaded', function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

jQuery(document).ready(function() {

    /*
    const defaultNavLink = jQuery(".navbar-fy .navbar-nav .nav-item:first-child .nav-link"); // Default to the first nav-link
    const savedNavLink = localStorage.getItem("activeNavLink");
    var savedNavFolded = localStorage.getItem("navFolded"); // Get the saved navigation state

    if (savedNavFolded == null) {
        // if new user show the navigation
        savedNavFolded = 'false';
        saveFolded("false");
    }

    // Restore the saved menu state
    if (savedNavFolded == 'false') {
        // alert('navFolded is ' + savedNavFolded);

        const activeLink = jQuery(`.navbar-fy .navbar-nav .nav-link[href="${savedNavLink}"]`);

        if (activeLink.length) {
            activateNavLink(activeLink);
        } else {
            activateNavLink(defaultNavLink); // If saved link doesn't exist, use the default
        }

        // turn all unfold checkboxes in the navigation off
        jQuery('.form-check-input-unfold').prop('checked', true);
    } else {
        // is true
        jQuery('.form-check-input-unfold').prop('checked', false);
    }

    // Handle click events for all nav-links
    jQuery(".navbar-fy .navbar-nav .nav-link").on("click", function (e) {
        // Activate the clicked link and save it
        localStorage.setItem("activeNavLink", jQuery(this).attr("href"));
    });

    // Function to activate a given nav-link
    function activateNavLink(link) {
        link.addClass("show"); // Add active classes
        
        if (link.hasClass("dropdown-toggle")) {
            link.next(".dropdown-menu").addClass("show"); // Show dropdown for dropdown links
            jQuery('body').addClass('padding-top-400');
        }
    }

    function foldNavigation(){
        jQuery('body').removeClass('padding-top-400').addClass('padding-top-100');
    }

    function unfoldNavigation(){
        jQuery('a.nav-link').removeClass('show');
        jQuery('.dropdown-menu').removeClass('show');

        // Check if the body doesn't already have the padding class for 400px
        if (!jQuery('body').hasClass('padding-top-400')) {
            jQuery('body').removeClass('padding-top-100').addClass('padding-top-400');
        }
    }

    function saveFolded(value = 'false') {
        localStorage.setItem("navFolded", value); // Save folded state
    }
    
    jQuery('.navbar-fy .dropdown').on('show.bs.dropdown', function () {
        unfoldNavigation();
        // saveFolded("false");

        // Add the rotated-icon class to the current dropdown toggle
        jQuery('.dropdown-toggle').removeClass('rotated-icon');
        jQuery(this).find('.dropdown-toggle').addClass('rotated-icon');
    });

    // When a dropdown menu is hidden
    jQuery('.navbar-fy .dropdown').on('hide.bs.dropdown', function () {
        foldNavigation();
        // saveFolded("true"); // Save folded state

        jQuery('.dropdown-toggle').removeClass('rotated-icon');
    });
 
    */



    jQuery('.form-check-input').change(function() {
        if (jQuery(this).is(':checked')) {
            // Call function when checkbox is checked
            saveFolded("false");
        } else {
            // Call function when checkbox is unchecked
            saveFolded("true");
        }
    });





 


    jQuery('.form-contact').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/contact/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {

                jQuery('#contact-form-body').hide();
                jQuery('#contact-form-message').show();

                /*
                jQuery(".form-add-event").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    jQuery('.form-join-email').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/join/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                }

                if (data.showpasswordfield) {
                    // user already has an account, let him login
                    jQuery('#join-password-wrapper').show();
                    jQuery('#join-password').focus();

                } else {
                    // user is NOT YET having an account, sign him up
                    if (data.mailresult && data.join_uuid) {
                        // mail was sent - forward user to code confirmation page
                        window.location.href = '/join/?action=confirm-show&uuid='+data.join_uuid;
                    } else {
                        alert('The email you entered cannot be used. Try another one.');
                    }
                } 


                // jQuery('#join-form-body').hide();
                // jQuery('#join-form-message').show();

                /*
                jQuery(".form-add-event").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    jQuery('.form-join-confirm').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/join-confirm/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {

            if (data.success) {

                console.log(data);

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                }

                /*
                jQuery(".form-add-event").trigger("reset");
                jQuery("#add-text").focus();

                jQuery('#add-message').html('<div class="alert alert-success"><h2>Form submitted successfully!</h2><a href="'+data.permalink+'" class="btn btn-success" target="_blank">View event</a></div>').show();

                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });

    jQuery('.call_event_showhide').on('click', function(event) {
        event.preventDefault();

        var post_id = jQuery(this).data('id');
        var title = jQuery(this).data('title');

        if (confirm("Do you want to report and hide the unverified event '"+title+"'?")){
            jQuery('#event-'+post_id).fadeOut(1000);

            // const formData = new FormData(this);
            var formData = new FormData();
            formData.append('post_id', post_id);

            // Submit form data via fetch
            fetch('/api/v1/showhide-event/', 
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        // 'X-WP-Nonce': nonce // Send the nonce in the request header
                    }
                })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // OK
                    // alert('Done!');
                } else {
                    alert('Error: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        };
    });

    jQuery(document).on('submit', '.call_yard_form', function(event) {
        event.preventDefault();

        // Collect form data
        const form = jQuery(this); // The form being submitted
        const formEntity = form.data('entity'); // Get the entity type
        let formData = form.serialize(); // Serialize form data

        // Add formEntity to the serialized data
        formData += `&entity=${encodeURIComponent(formEntity)}`;

        // Get the nonce value from the form
        const nonce = form.find('input[name="form_nonce"]').val();

        jQuery('.call_yard_form').find('input, textarea, select, button').prop('disabled', true);
        jQuery('#yard-loader-modal').show();

        // Submit form data via fetch
        fetch('/api/v1/set-yardform/', 
            {
                method: 'POST',
                // credentials: 'same-origin',
                credentials: 'include', 
                body: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {

                console.log( data.redirect_url );

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                } else {
                    console.log('Form was saved.');
                    jQuery('.call_yard_form').find('input, textarea, select, button').prop('disabled', false);
                    jQuery('#yard-loader-modal').hide();
                }

                if (formEntity == 'join-fields') {
                    // hide all steps
                    jQuery('.join-step').hide();

                    // fill step with current html, if existing
                    if (data.html != '') {
                        jQuery('#'+data.showstep).html(data.html);
                    }
                    
                    // show current step
                    jQuery('#'+data.showstep).show();

                    if (data.javascript) {
                        try {
                            // Execute the JavaScript code in data.javascript
                            eval(data.javascript);
                        } catch (e) {
                            console.error('Error executing JavaScript:', e);
                        }
                    }
                }

                if (formEntity == 'contact') {
                    jQuery('#yard-contact-body').hide();
                    jQuery('#yard-modal-contact-undefined .btn-primary').hide();
                    jQuery('#yard-contact-message').show();
                }

                if (formEntity == 'eventmanage') {
                    jQuery('#yard-eventmanage-body').hide();
                    jQuery('.modal-footer-form-button .btn-primary').hide();
                    jQuery('#yard-eventmanage-message').show();
                }
                
            } else {
                alert('Error: ' + data.message);
                jQuery('.call_yard_form').find('input, textarea, select, button').prop('disabled', false);
                jQuery('#yard-loader-modal').hide();
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    jQuery(document).on('click', '.call_changemodaldisplay', function(event) {
        var mode = jQuery(this).data('display');
    
        if (mode == "show-expert") {
            // show expert
            jQuery('.modaldisplay_default_basic').removeClass('modaldisplay_hide');
            jQuery('#changemodaldisplay-expert').show();
            jQuery('#changemodaldisplay-basic').hide();
        } else {
            // show basic
            jQuery('.modaldisplay_default_basic').addClass('modaldisplay_hide');
            jQuery('#changemodaldisplay-expert').hide();
            jQuery('#changemodaldisplay-basic').show();
        }
    });


    jQuery(document).on('click', '.call_modal', function(event) {
        event.preventDefault();

        console.log(' .call_modal in custom-javascript.js ');
        
        var id = jQuery(this).data('id');
        var entity = jQuery(this).data('entity');

        var display = jQuery(this).data('display'); // "expert" or "basic", if defined
        var showcity = jQuery(this).data('showcity'); // "true" or "false", if defined

        var fetchurl = '/api/v1/get-yardmodal/?id='+id+'&entity='+entity;

        if (display) {
            fetchurl += '&display='+display;
        }

        if (showcity) {
            fetchurl += '&showcity='+showcity;
        }

        // Submit form data via fetch
        fetch(fetchurl, 
            {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {

            if (data.success) {
                var modalId = '#yard-modal-' + entity + '-' + id;

                jQuery('body').append(data.modal);
                jQuery(modalId).modal('show');

                jQuery(document).on('shown.bs.modal', function () {
                    var modals = jQuery('.modal.show');
                    var backdrops = jQuery('.modal-backdrop');
                
                    modals.each(function (index) {
                        var $modal = jQuery(this);
                        var modalZIndex = 1050 + (index * 20); // Unique zIndex for each modal
                        $modal.css('z-index', modalZIndex);
                
                        // Ensure each backdrop is above the previous modal and backdrop
                        if (backdrops[index]) {
                            jQuery(backdrops[index]).css('z-index', modalZIndex - 5); // Backdrop is just below the next modal
                        }
                    });
                });
                
                // Attach an event listener to remove the modal from DOM when it's closed
                jQuery(modalId).on('hidden.bs.modal', function() {
                    jQuery(this).remove();
                });                
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });

    });


    jQuery('.form-save-card-feedback').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/save-card-feedback/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                jQuery(".form-add-event").trigger("reset");
                jQuery("#form-save-card").hide();
                jQuery('#message-save-card').show();

                /*
                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    document.querySelectorAll('.dropdown-filter').forEach(dropdown => {
        const button = dropdown.querySelector('.dropdown-toggle');
        const items = dropdown.querySelectorAll('.dropdown-item');
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
    
        items.forEach(item => {
          item.addEventListener('click', function(event) {
            event.preventDefault();
    
            // Remove the active class from all dropdown items in this dropdown
            items.forEach(i => i.classList.remove('active'));
    
            // Add the active class to the clicked item
            this.classList.add('active');
    
            // Get selected value and text (icon + text)
            const selectedValue = this.getAttribute('data-value');
            const selectedText = this.innerHTML;

            // Update the button to show the selected item (with icon)
            button.innerHTML = selectedText;
    
            // Update the hidden input value
            hiddenInput.value = selectedValue;
          });
        });
    });




});